import styled from "@emotion/styled";

export const IndentSpacer = styled.span({
    width: 6,
});
